import CenteredPage from './CenteredPage';

export default CenteredPage;
